export const formatMoney = (value: string | number, currency: string | null = 'USD'): string => {
  if (value === null || value === undefined) return ''
  return (typeof value === 'string' ? parseFloat(value) : value).toLocaleString('en-US', {
    ...(currency && {
      style: 'currency',
      currency: currency,
    }),
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export const formatCurrency = (value: number) => {
  if (value === null) return '$ 0'
  const parts = value.toFixed(2).split('.')

  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

  const formattedValue = parts[1] === '00' ? parts[0] : parts.join(',')

  return `$ ${formattedValue}`
}
